import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async"; // ✅ IMPORT ADDED HERE
import "./index.css";
import RouteSeo from "./components/RouteSeo";

// App shell
import App from "./App";

// About
import VisionMissionPage from "./about/VisionMission";
import EducationPolicies from "./about/Education-Policies";
import ChairmanMessage from "./about/ChairmanMessage";
import CeoMessage from "./about/ceo";
import DirectorMesage from "./about/director";
import Governing from "./about/governing";
import Advisory from "./about/advisory";
import AcademicCouncil from "./about/academic-council";
import DevelopmentCommittee from "./about/development-committee";
import IqacCommittee from "./about/IqacCommittee";
import CellCommittee from "./about/CellCommittee";
import Organogram from "./about/Organogram";

// Programs
import MCAProgram from "./program/MCA";
import IntegratedMCAProgram from "./program/IntegratedMCA";
import ProfessionalMCAProgram from "./program/ProfessionalsMCA";
import PhdAccordion from "./program/PhdAccordion";

// Contact
import ContactPage from "./contact/ContactPage";
import GrievanceForm from "./contact/GrievanceForm";
import Recruitment from "./contact/Recruitment";
import Employment from "./contact/Employment";

// Examination
import NoticeBoard from "./Examination/NoticeBoard";
import MCAResults from "./Examination/UniversityGazette";
// import ResultAnalysis from "./Examination/ResultAnalysis";
import Convocation from "./Examination/Convocation";
import ExamScheduleResource from "./Examination/ExamScheduleResource";

// Facilities
import Infrastructure from "./Facilities/Infrastructure";
import InfrastructureGallery from "./Facilities/InfrastructureGallery";
import DRC from "./Facilities/DRC"; // If DRC and InfrastructureDFC are the same, keep only one import
import InfrastructureDFC from "./Facilities/DRC"; // Duplicates DRC import; consider removing one if unintended

// Academics
import FacultyTable from "./academics/facultytable";
import Faculty from "./academics/facultydetails";
import Nonteachingfaculty from "./academics/non-teachingstaf";
import Studentdownload from "./academics/studentdownload";

// Placement

import TrainingProgramme from "./placement/TrainingProgramme";
import PlacementData from "./placement/Placementdata";

// R&D
import IoTLabExcellence from "./RD/IoTLabExcellence";
import TechTonics from "./RD/TechTonics";
import Consultancy from "./RD/Consultancy";
import ResearchCell from "./RD/ResearchCell";
import IIC from "./RD/IIC";
import ICAIM2025 from "./RD/Icaims/ICAIMPage";

// Library
import LibraryPage from "./Facilities/LibraryPage";
import LibraryInfrastructure from "./Facilities/LibraryInfrastructure";
import LibraryHolding from "./Facilities/LibraryHolding";
import LibraryRules from "./Facilities/LibraryRules";

// Admissions
import IMCA_Admission from "./Admissions/IMCA_Admission";
import MCA_Admission from "./Admissions/MCA_Admission";
import MCA_WorkingProfessional from "./Admissions/MCA_WorkingProfessional";
import SeatDistribution from "./Admissions/SeatDistribution";
import FeesStructure from "./Admissions/FeesStructure";
import AdmissionNotifications from "./Admissions/AdmissionNotifications";
import AICTEApproval from "./Admissions/AICTEApproval";
import StudentHandbook from "./Admissions/StudentHandbook";
import StudentMentoring from "./Admissions/StudentMentoring";
import AntiRagging from "./Admissions/AntiRagging";

// Life @
import FacultyPrograms from "./Life/FacultyPrograms";
import STTPPrograms from "./Life/STTPPrograms";
import ParentInteractionProgramme from "./Life/ParentInteractionProgramme ";
import IEEEPage from "./Life/IEEEPage";
import StudentDevelopmentProgram from "./Life/StudentDevelopmentProgram";
import PrePlacementTraining from "./Life/PrePlacementTraining ";
import Admin from "./admin/Admin";
import AdminLogin from "./admin/AdminLogin";
import IndustrialVisits from "./Life/studentactivity/IndustrialVisits";
import ECellAyan from "./Life/studentactivity/E-CellAyan";
import Synapse from "./Life/studentactivity/Synapse";
import Vista from "./Life/studentactivity/Vista";
import DLLE from "./Life/studentactivity/DLLE";
import GreenClub from "./Life/studentactivity/GreenClub";
import CodingClub from "./Life/studentactivity/CodingClub";
import Trekking from "./Life/Events/Trekking";
import SocialEvents from "./Life/Events/SocialEvents";
import Hackathon from "./Life/Events/Hackathon";
import HealthHygiene from "./Life/Events/Health&Hygiene";
import CleanIndiaCampaign from "./Life/Events/CleanIndiaCampaign";
import SelfDefence from "./Life/WomensCell/Selfdefence";
import WomenEntrepreneurs from "./Life/WomensCell/WomenEnterpreneurs";
import WomenHealth from "./Life/WomensCell/WomenHealth";
import BharatAbhiyan from "./Life/UnnatBharatAbhiyan/BharatAbhiyan";
import CulturalDay from "./Life/RecreationalPrograms/CulturalDay";
import FreshersFarewell from "./Life/RecreationalPrograms/Freshers&Farewell";
import SportsDay from "./Life/RecreationalPrograms/SportsDay";
import PEOPage from "./program/PEOPage";
import EventGalleryDisplay from "./Life/EventGalleryDisplay";
import NetworkingLab from "./Life/professionalbodies/NetworkingLab";
// Celebration Gallery - Updated

import Y from "./Life/yuvostav/Yuvostav";
import CodeOfConduct from "./Admissions/CodeOfConduct";
import GuestSession from "./Life/GuestSession";
import Blogs from "./Life/blogs/blogs";
import FRAFeeStructure from "./FRA/FRAFeeStructure";
import IntegratedMca from "./FRA/IntegratedMca";
import Wpmca from "./FRA/Wpmca";
import PHD from "./FRA/PHD";
import SplashPdfViewer from "./about/OurPolicies";
import NispPolicy from "./about/NispPolicy";
import PhdDocument from "./program/PhdDocument";
import CanditateAganistCap from "./Admissions/CanditateAganistCap";
import AlumniAssociation from "./alumni/AlumniAssociation";
import AlumniInteraction from "./alumni/AlumniInteraction";
import StudentTestimonials from "./alumni/StudentTestimonials";
import LibraryCommittee from "./Facilities/LibraryCommittee";
import VirtualReadingResource from "./Facilities/VirtualReadingResource ";
import NationalConference from "./RD/NationalConference";
import Icaim23 from "./RD/Icaims/Icaim23";
import Icaim24 from "./RD/Icaims/Icaim24";
import Icaim22 from "./RD/Icaims/Icaim22";
import Icaim21 from "./RD/Icaims/Icaim21";
import Icaim20 from "./RD/Icaims/Icaim20";
import NaacIiqa from "./Iqac/Naac-IIqa";
import Naacssr from "./Iqac/Naac-ssr";
import NaacCertificate from "./Iqac/Naac-certificate";
import NaaqAqar from "./Iqac/Naac-aqar";

import TrainingAndPlacement from "./placement/TrainingAndPlacement";
import ResultAnalysis from "./Examination/ResultAnalysis1";
import ErrorNa from "./errors/error-na";
import CSITimsCdr from "./Life/CSITimsCdr";
import ICTBasedLearning from "./academics/ICTBasedLearning";
import Ipr from "./RD/IPR";
import Aboutplacement from "./placement/Aboutplacement";
import IQACMOM from "./Iqac/IQAC-MOM";
import AiceteFaculty from "./contact/AiceteFaculty";
import Uom from "./contact/Uom";
import UoMQualification from "./contact/UoM-Qualification";
import DistinguishedAlumni from "./alumni/DistinguishedAlumni";
import CollegeGrievanceCommittee from "./quickLinks/CollegeGrievanceCommittee";
import Icaim26 from "./RD/Icaims/Icaim26";
import WomensGrievanceCommittee from "./quickLinks/WomensGrievanceCommittee.jsx";
import ClassImprovementMCA from "./quickLinks/ClassImprovementMCA.jsx";
import Downloads from "./quickLinks/downloads.jsx";
import FeedBack from "./quickLinks/FeedBack.jsx";
import MandatoryDisclosure from "./quickLinks/MandatoryDisclosure.jsx";
import RTI from "./quickLinks/RTI.jsx";
import ContentPolicy from "./quickLinks/contentPolicy.jsx";
import DisclaimerPage from "./quickLinks/DisclaimerPage.jsx";
import AdmissionProcess from "./components/AdmissionProcess.jsx";
import DoctorsBooklet from "./Life/DoctorsBooklet.js";
import EmployeeHandbook from "./Life/EmployementHandbook.jsx";
import MagazineEminence from "./Life/MagazineEminence.js";
import Newsletter from "./Life/Newsletter.js";

// Optional Web Vitals (uncomment when needed)
// import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
const routerBasename = process.env.PUBLIC_URL && process.env.PUBLIC_URL !== "." ? process.env.PUBLIC_URL : "/";

function SeoLayout() {
  return (
    <>
      <RouteSeo />
      <Outlet />
    </>
  );
}

root.render(
  /* ✅ HELMETPROVIDER WRAPS EVERYTHING HERE */
<HelmetProvider>
    <BrowserRouter basename={routerBasename}>
      <Routes>
        <Route element={<SeoLayout />}>
          {/* Home */}
          <Route path="/" element={<App />} />

          {/* ADMINPANEL */}
          <Route path="/admin-login-timscdr" element={<AdminLogin />} />
          <Route path="/admin-timscdr" element={<Admin />} />

          <Route path="/admission-procedure-2" element={<AdmissionProcess />} />

          {/* About */}
          <Route path="/vision-mission/" element={<VisionMissionPage />} />
          <Route path="/quality-policy/" element={<EducationPolicies />} />
          <Route path="/chairmans-message/" element={<ChairmanMessage />} />
          <Route path="/ceos-message/" element={<CeoMessage />} />
          <Route path="/directors-message/" element={<DirectorMesage />} />
          <Route path="/governing-council/" element={<Governing />} />
          <Route path="/advisory-board/" element={<Advisory />} />
          <Route path="/academic-council/" element={<AcademicCouncil />} />
          <Route path="/college-development-committee/" element={<DevelopmentCommittee />} />
          <Route path="/iqac-committee/" element={<IqacCommittee />} />
          <Route path="/cells-and-committees/" element={<CellCommittee />} />
          <Route path="/about/nisp-policy" element={<NispPolicy />} /> {/* Kept original as no exact match in sitemap */}
          <Route path="/policies" element={<SplashPdfViewer />} />
          <Route path="/organogram" element={<Organogram />} />
          <Route path="*" element={<ErrorNa />} />
          
          {/* Programs */}
          <Route path="/peo-Page" element={<PEOPage />} />
          <Route path="/program/" element={<MCAProgram />} />
          <Route path="/integrated-mca/" element={<IntegratedMCAProgram />} />
          <Route path="/program-mca-working-professionals/" element={<ProfessionalMCAProgram />} />
          <Route path="/ph-d-admission/" element={<PhdAccordion />} />
          <Route path="/phd-admission/" element={<PhdDocument />} /> {/* Kept original typo/route to prevent breaking component if needed */}



          {/* Contact */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/student-grievance-redressal/" element={<GrievanceForm />} />
          <Route path="/recruitment/" element={<Recruitment />} />
          <Route path="/employees-handbook/" element={<Employment />} />
          <Route path="/contact/aicte-faculty" element={<AiceteFaculty />} />
          <Route path="/contact/uom" element={<Uom />} />
          <Route path="/contact/uom-qualification" element={<UoMQualification />} />

          {/* Examination */}
          <Route path="/notice/" element={<NoticeBoard />} />
          <Route path="/university-schedule/" element={<ExamScheduleResource />} />
          <Route path="/university-gazette/" element={<MCAResults />} />
          <Route path="/result-analysis/" element={<ResultAnalysis />} />
          <Route path="/convocation/" element={<Convocation />} />

          {/* Facilities */}
          <Route path="/infrastructure/" element={<Infrastructure />} />
          <Route path="/infrastructure-gallery/" element={<InfrastructureGallery />} />
          <Route path="/drc/" element={<InfrastructureDFC />} />

          {/* Library */}
          <Route path="/about-library/" element={<LibraryPage />} />
          <Route path="/infrastructure-and-facilities/" element={<LibraryInfrastructure />} />
          <Route path="/timscdr-library-holding/" element={<LibraryHolding />} />
          <Route path="/library-timing-and-rules/" element={<LibraryRules />} />
          <Route path="/library-committee/" element={<LibraryCommittee />} />
          <Route path="/virtual-reading-resource/" element={<VirtualReadingResource />} />

          {/* IQAC */}
          <Route path="/iqac/naac-iiqa" element={<NaacIiqa />} />
          <Route path="/iqac/naac-ssr" element={<Naacssr />} />
          <Route path="/iqac-committee/" element={<IqacCommittee />} />
          <Route path="/iqac-mom" element={<IQACMOM />} />
          <Route path="/NAAC-Certificate" element={<NaacCertificate />} />
          <Route path="/naac-aqar" element={<NaaqAqar />} />

          {/* FRA */}
          <Route path="/fra-fee-structure/" element={<FRAFeeStructure />} />
          <Route path="/integrated-mca-2/" element={<IntegratedMca />} />
          <Route path="/phd" element={<PHD />} />
          <Route path="/Working-professional-fra" element={<Wpmca />} />

          {/* Admissions */}
          <Route path="/imca/" element={<IMCA_Admission />} />
<Route path="/master-of-computer-applications-mca/" element={<MCA_Admission />} />
<Route path="/mca-working-professionals/" element={<MCA_WorkingProfessional />} />
          <Route path="/seat-distribution/" element={<SeatDistribution />} />
          <Route path="/fees-structure/" element={<FeesStructure />} />
          <Route path="/admission-notification/" element={<AdmissionNotifications />} />
          <Route path="/aicte-approval-2/" element={<AICTEApproval />} />
          <Route path="/student-handbook/" element={<StudentHandbook />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/student-mentoring-program/" element={<StudentMentoring />} />
          <Route path="/anti-ragging/" element={<AntiRagging />} />
          <Route path="/canditate-aganist-cap" element={<CanditateAganistCap />} />



          {/* R&D */}
          <Route path="/research-cell/" element={<ResearchCell />} />
          <Route path="/institution-innovation-council-iic/" element={<IIC />} />
          <Route path="/ipr/" element={<Ipr />} />
          <Route path="/icaim-2026/" element={<Icaim26 />} />
          <Route path="/icaim-2025/" element={<ICAIM2025 />} />
          <Route path="/international-conferenceicaim-2023/" element={<Icaim23 />} />
          <Route path="/icaim-2024/" element={<Icaim24 />} />
          <Route path="/international-conferenceicaim-2022/" element={<Icaim22 />} />
          <Route path="/icaim-2021/" element={<Icaim21 />} />
          <Route path="/international-conferenceicaim-2020/" element={<Icaim20 />} />
          <Route path="/iot-excellence/" element={<IoTLabExcellence />} />
          <Route path="/techtonics/" element={<TechTonics />} />
          <Route path="/consultancy/" element={<Consultancy />} />
          <Route path="/national-conference-2025/" element={<NationalConference />} />
          <Route path="/doctor-booklet/" element={<DoctorsBooklet />} />

          {/* Academics */}
          <Route path="/faculty-list-2/" element={<FacultyTable />} />
          <Route path="/staff/" element={<Faculty />} />
          <Route path="/non-teaching-staff/" element={<Nonteachingfaculty />} />
          <Route path="/student-downloads/" element={<Studentdownload />} />
          <Route path="/teaching-pedagogy/" element={<ICTBasedLearning />} />

          {/* Placement */}
          <Route path="/best-mca-college-in-mumbai-for-placements-about-placement/" element={<Aboutplacement />} />
          <Route path="/training-programme/" element={<TrainingProgramme />} />
          <Route path="/placement-data/" element={<PlacementData />} />
          <Route path="/training-and-placement-policy/" element={<TrainingAndPlacement />} />

          {/* Life @ */}
          <Route path="/life/industrial-visit" element={<IndustrialVisits />} />
          <Route path="/life/e-cell-ayan" element={<ECellAyan />} />
          <Route path="/life/synapse" element={<Synapse />} />
          <Route path="/life/vista" element={<Vista />} />
          <Route path="/life/dlle" element={<DLLE />} />
          <Route path="/life/green-club" element={<GreenClub />} />
          <Route path="/life/coding-club" element={<CodingClub />} />
          <Route path="/csi-timscdr" element={<CSITimsCdr />} />
          <Route path="/life/trekking" element={<Trekking />} />
          <Route path="/life/socialevents" element={<SocialEvents />} />
          <Route path="/life/hackathon" element={<Hackathon />} />
          <Route path="/life/health-hygiene" element={<HealthHygiene />} />
          <Route path="/life/clean-india-campaign" element={<CleanIndiaCampaign />} />
          <Route path="/ieee-timscdr" element={<IEEEPage />} />
          <Route path="/life/selfdefence" element={<SelfDefence />} />
          <Route path="/life/womenentepreneurs" element={<WomenEntrepreneurs />} />
          <Route path="/life/womenhealth" element={<WomenHealth />} />
          <Route path="/d-link-academy-lab" element={<NetworkingLab />} />
          <Route path="/life/bharatabhiyan" element={<BharatAbhiyan />} />
          <Route path="/life/magazine-eminence" element={<MagazineEminence />} />
          <Route path="/life/newsletter" element={<Newsletter />} />
          <Route path="/life/yuvostav" element={<Y />} />
          <Route path="/life/culturalday" element={<CulturalDay />} />
          <Route path="/life/fresher-farewell" element={<FreshersFarewell />} />
          <Route path="/life/sportsday" element={<SportsDay />} />

          {/* Alumni */}
          <Route path="/alumni-association/" element={<AlumniAssociation />} />
          <Route path="/alumni-interaction" element={<AlumniInteraction />} />
          <Route path="/our-distinguished-alumni/" element={<DistinguishedAlumni />} />
          <Route path="/alumni-testimonials/" element={<StudentTestimonials />} />

          <Route path="/event-galleries" element={<ErrorNa />} />
          
          {/* Quick Links */}
          <Route path="/blogs/" element={<Blogs />} />
          <Route path="/college-grievance-redressal-committee/" element={<CollegeGrievanceCommittee />} />
          <Route path="/womens-grievance-redressal-committee/" element={<WomensGrievanceCommittee />} />
          <Route path="/Class-Improvement-MCA" element={<ClassImprovementMCA />} />
          <Route path="/downloads/" element={<Downloads />} />
          <Route path="/feedback/" element={<FeedBack />} />
          <Route path="/mandatory-disclosure" element={<MandatoryDisclosure />} />
          <Route path="/RTI" element={<RTI />} />
          <Route path="/content-policy/" element={<ContentPolicy />} />
          <Route path="/disclaimer/" element={<DisclaimerPage />} />
          <Route path="/faculty-development-programme/" element={<FacultyPrograms />} />
          <Route path="/short-term-training-programme/" element={<STTPPrograms />} />
          <Route path="/employees-handbook/" element={<EmployeeHandbook />} />
          <Route path="/parent-interaction-programme/" element={<ParentInteractionProgramme />} />
          <Route path="/guest-lecture-sdp-pre-placement-training/" element={<GuestSession />} />
          <Route path="/student-development-program/" element={<StudentDevelopmentProgram />} />
          <Route path="/pre-placement-training/" element={<PrePlacementTraining />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </HelmetProvider>
);